import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { LanguageProvider } from './context/LanguageContext'
import { AuthProvider } from './context/AuthContext'
import { AudioProvider } from './context/AudioContext'
import { DevModeProvider } from './context/DevModeContext'
import './styles/global.css'
import './styles/study.css'
import { captureAttribution } from './lib/access'
import { captureRedeemEntry } from './lib/redeemEntry'

// Remember campaign tags from the landing URL for a later subscription.
captureAttribution()

// ?redeem=1 — a teacher following their link. Read and stripped from the URL
// before React mounts, so the parameter never reaches the address bar.
captureRedeemEntry()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LanguageProvider>
      <AuthProvider>
        <AudioProvider>
          <DevModeProvider>
            <App />
          </DevModeProvider>
        </AudioProvider>
      </AuthProvider>
    </LanguageProvider>
  </React.StrictMode>
)
